import './Card.css';
import Delay from 'react-delay';
export default function Card(props) {

    return (
        <Delay wait={150}><div className={`Card ${props.className}`}>{props.children}</div></Delay>
    );
}